var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 158.927,
    y: 364.463,
    style: {
      fill: "#4C9CBF"
    },
    width: 194.146,
    height: 78.841
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.55,
    y: 37.932,
    style: {
      fill: "#4C9CBF"
    },
    width: 16.9,
    height: 71.918
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E88158"
    },
    cx: 256,
    cy: 23.191,
    r: 23.191
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D37250"
    },
    d: "M249.491,23.191c0-9.863,6.168-18.267,14.849-21.619c-2.591-1-5.398-1.572-8.342-1.572 c-12.808,0-23.191,10.383-23.191,23.191s10.383,23.191,23.191,23.191c2.945,0,5.75-0.571,8.342-1.572 C255.66,41.458,249.491,33.054,249.491,23.191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E88158"
    },
    d: "M306.699,152.099c0-28.001-22.699-50.7-50.7-50.7s-50.7,22.699-50.7,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D37250"
    },
    d: "M255.999,101.398c-10.275,0-18.59,22.702-18.59,50.7h-32.11 C205.299,124.1,227.99,101.398,255.999,101.398z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DACD8"
    },
    d: "M419.368,201.648v132.991c0,27.367-22.184,49.55-49.55,49.55H142.176 c-27.355,0-49.539-22.184-49.539-49.55V201.648c0-27.367,22.184-49.55,49.539-49.55h227.641 C397.184,152.098,419.368,174.282,419.368,201.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DACD8"
    },
    d: "M419.364,512v-38.879c0-27.364-22.183-49.547-49.547-49.547H142.179 c-27.364,0-49.547,22.183-49.547,49.547V512"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C9CBF"
    },
    d: "M184.422,384.19h-42.238c-27.367,0-49.55-22.184-49.55-49.55V201.648 c0-27.367,22.184-49.55,49.55-49.55h42.238c-27.355,0-49.539,22.184-49.539,49.55v132.991 C134.883,362.006,157.067,384.19,184.422,384.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C9CBF"
    },
    d: "M184.422,423.578c-27.355,0-49.539,22.184-49.539,49.539v38.881h-42.25v-38.881 c0-27.355,22.184-49.539,49.55-49.539H184.422z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A872"
    },
    d: "M299.198,309.831h-86.401c-17.831,0-32.286,14.455-32.286,32.286v42.074h150.972v-42.074 C331.485,324.286,317.03,309.831,299.198,309.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09461"
    },
    d: "M299.198,309.831h-86.401c-17.831,0-32.286,14.455-32.286,32.286v22.533 c0-17.831,14.455-32.286,32.286-32.286h86.401c17.83,0,32.286,14.455,32.286,32.286v-22.533 C331.485,324.286,317.03,309.831,299.198,309.831z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DDA758"
    },
    cx: 349.93,
    cy: 248.992,
    r: 32.673
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDA758"
    },
    d: "M194.746,248.99c0,3.864-0.665,7.56-1.904,10.996c-4.507,12.641-16.584,21.677-30.769,21.677 s-26.262-9.036-30.769-21.677c-1.239-3.436-1.904-7.132-1.904-10.996c0-18.049,14.624-32.673,32.673-32.673 S194.746,230.941,194.746,248.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4BD64"
    },
    d: "M192.842,259.987c-4.507,12.641-16.584,21.677-30.769,21.677s-26.262-9.036-30.769-21.677 c4.507-12.641,16.573-21.688,30.769-21.688S188.335,247.346,192.842,259.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4BD64"
    },
    d: "M380.694,259.987c-4.507,12.641-16.584,21.677-30.769,21.677s-26.262-9.036-30.769-21.677 c4.507-12.641,16.573-21.688,30.769-21.688C364.121,238.299,376.187,247.346,380.694,259.987z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C9CBF"
    },
    d: "M349.925,290.115c-22.675,0-41.123-18.448-41.123-41.123s18.448-41.123,41.123-41.123 c22.675,0,41.123,18.448,41.123,41.123S372.6,290.115,349.925,290.115z M349.925,224.768c-13.357,0-24.223,10.867-24.223,24.223 c0,13.357,10.867,24.223,24.223,24.223c13.357,0,24.223-10.867,24.223-24.223C374.148,235.635,363.283,224.768,349.925,224.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C9CBF"
    },
    d: "M162.073,290.115c-22.675,0-41.123-18.448-41.123-41.123s18.448-41.123,41.123-41.123 s41.123,18.448,41.123,41.123S184.748,290.115,162.073,290.115z M162.073,224.768c-13.357,0-24.223,10.867-24.223,24.223 c0,13.357,10.867,24.223,24.223,24.223s24.223-10.867,24.223-24.223C186.296,235.635,175.429,224.768,162.073,224.768z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 204.343,
    y: 301.381,
    style: {
      fill: "#5DACD8"
    },
    width: 16.9,
    height: 82.809
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.746,
    y: 301.381,
    style: {
      fill: "#5DACD8"
    },
    width: 16.9,
    height: 82.809
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.55,
    y: 301.381,
    style: {
      fill: "#5DACD8"
    },
    width: 16.9,
    height: 82.809
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.376,
    y: 453.976,
    style: {
      fill: "#666666"
    },
    width: 50.696,
    height: 16.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.376,
    y: 481.016,
    style: {
      fill: "#666666"
    },
    width: 50.696,
    height: 16.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.925,
    y: 453.976,
    style: {
      fill: "#666666"
    },
    width: 50.697,
    height: 16.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.925,
    y: 481.016,
    style: {
      fill: "#666666"
    },
    width: 50.697,
    height: 16.9
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C9CBF"
    },
    d: "M339.935,384.191h-16.9v-42.074c0-13.144-10.692-23.836-23.836-23.836h-86.401 c-13.144,0-23.836,10.693-23.836,23.836v42.074h-16.9v-42.074c0-22.462,18.274-40.736,40.735-40.736h86.401 c22.462,0,40.735,18.274,40.735,40.736V384.191z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.64b154a2c892a04461d6686a7e4427c0.svg";
export { ForwardRef as ReactComponent };